import { useEffect, useState } from "react";
import moment from "../../../node_modules/moment/moment";
import { Link, useLocation, useParams } from "../../../node_modules/react-router-dom/dist/index";
import _ from "lodash";
import { GET_ALL_MOVIE_RESOURCE, GET_MOVIE_RATING_BY_ID, fetchData } from "../../components/Service";
import { scrollTop } from "../../components/Helper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';

const MovieReviewsDetails = () => {
	const { movie_review_id } = useParams();
	const [data, setData] = useState();
	const [resourceData, setResourceData] = useState();
	const [ratings, setRatings] = useState();
	const [rating, setRating] = useState(1);
	const [hover, setHover] = useState(0);


	const getDetails = (reid) => {
		let payload = {
			id: reid,
		};

		fetchData(GET_MOVIE_RATING_BY_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setData(res?.data);
				setRatings(JSON.parse(res?.data?.rating_data));
				console.log(JSON.parse(res?.data?.rating_data));
			} else {
				setData();
				setRatings();
			}
		});
	};

	const getMovieResource = () => {
		fetchData(GET_ALL_MOVIE_RESOURCE, "GET", "", false, false, (res) => {
			if (res.status) {
				setResourceData(res?.data);
			} else {
				setResourceData();
			}
		});
	};

	useEffect(() => {
		if (movie_review_id) {
			getDetails(movie_review_id);
		}
	}, [movie_review_id]);

	useEffect(() => {
		scrollTop();
		getMovieResource();
	}, []);
	return (
		<div class="col-lg-12">
			<div class="card card-forum ">
				<div class="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 class="text-white d-flex mb-0 py-2">{data?.name}</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1">
					<div class="card mb-3">
						<div class="row g-0 align-items-stretch">
							<div class="col-xl-6">
								<img src={data?.image ? data?.image : "/assets/images/no-image.jpg"} class="img-fluid rounded-3" />
							</div>
							<div class="col-xl-6">
								<div class="card-body h-100">
									<table className="table table-borderless table-sm">
										<tr>
											<td className="ps-0">
												<h6>Movie Rating:</h6>
											</td>
											<td>
												<div className="rating mt-1">
													{(() => {
														if (!ratings || Object.keys(ratings).length === 0) return null;

														const total = Object.values(ratings).reduce((sum, [rating]) => sum + Number(rating || 0), 0);
														const count = Object.values(ratings).length;
														const average = total / count;

														const stars = [];
														for (let i = 1; i <= 5; i++) {
															if (i <= Math.floor(average)) {
															  stars.push(
																<FontAwesomeIcon
																  key={`star-${i}`}
																  icon={solidStar}
																  style={{ color: '#ffcc00', fontSize: '32px' }}
																/>
															  );
															} else if (i - average <= 0.5) {
															  stars.push(
																<FontAwesomeIcon
																  key={`star-${i}`}
																  icon={faStarHalfAlt}
																  style={{ color: '#ffcc00', fontSize: '32px' }}
																/>
															  );
															} else {
															  stars.push(
																<FontAwesomeIcon
																  key={`star-${i}`}
																  icon={regularStar}
																  style={{ color: '#ccc', fontSize: '32px' }}
																/>
															  );
															}
														  }

														return stars;
													})()}
												</div>
											</td>
										</tr>
									</table>
									<div>
										<table class="table test-white  mb-0  table-borderless table-sm">
											{resourceData?.map((item, index) => (
												<tr key={item.id}>
													{ratings[item.id] && (
														<td class="p-0 font14">
															{ratings[item.id] && ratings[item.id][1] ? (
																<Link to={ratings[item.id][1]} target="_blank">
																	{item?.name}
																</Link>
															) : (
																<Link to="#">{item?.name}</Link>
															)}
														</td>
													)}
													{ratings[item.id] && <td class="p-0 font14">{ratings[item.id] && ratings[item.id][0] ? ratings[item.id][0] : 0}</td>}
												</tr>
											))}
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MovieReviewsDetails;
